import PublishersLandingPage from "@components/publishers";
import {
  PagePublishersLandingComp,
  ssrPublishersLanding,
} from "@graphql/generated/page";
import { loadTranslation } from "@lib/utils";
import { GetStaticProps } from "next";
import { t } from "@lingui/macro";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV == "production"
  );

  const {
    props: { data },
  } = await ssrPublishersLanding.getServerPage({});

  return { props: { data, translation, locale } };
};
const Publishers: PagePublishersLandingComp = ({ data }) => {
  const router = useRouter();
  const title = t`Publishers - Lumi News`;
  const description = t`List of Malaysia's top publishers that are now on Lumi. Read news and watch videos from your favourite publishers all in one place.`;
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          url: "https://luminews.my" + router.asPath,
          title: title,
          description: description,
        }}
      />
      <PublishersLandingPage data={data} />
    </>
  );
};

export default Publishers;
